import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DueslagPageRoutingModule } from './dueslag-routing.module';

import { DueslagPage } from './dueslag.page';
import { FilelistComponent } from '../../components/filelist/filelist.component';

import { NgPipesModule } from 'ngx-pipes';
import { FilelistRootComponent } from '../../components/filelist-root/filelist-root.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { MainnavigationComponent } from '../../components/mainnavigation/mainnavigation.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DueslagPageRoutingModule,
    NgPipesModule
  ],
  declarations: [DueslagPage, FilelistComponent, FilelistRootComponent, BreadcrumbComponent, MainnavigationComponent]
})
export class DueslagPageModule {}
